<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-11",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 31,
      nextPage: '/questionnaire/section2/12',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'cardBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Hair.png'),
        mainTitle: 'Your hair is:',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Dry',
              icon: require('@/assets/icon/questionIcon/35-Dry.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/35-Dry.png'),
            },{
              text: 'Damaged',
              clickedIcon: require('@/assets/icon/clickedIcon/35-Damaged.png'),
              icon: require('@/assets/icon/questionIcon/30-Damaged.png')
            },{
              text: 'Growing slowly',
              clickedIcon: require('@/assets/icon/clickedIcon/35-Growing slowly.png'),
              icon: require('@/assets/icon/questionIcon/30-Growing slowly.png')
            }
          ],[
            {
              text: 'Starting to thin',
              clickedIcon: require('@/assets/icon/clickedIcon/35-Starting to thin.png'),
              icon: require('@/assets/icon/questionIcon/30-Starting to thin.png')
            },{
              text: 'None of these',
              clickedIcon: require('@/assets/icon/clickedIcon/35-None of these.png'),
              icon: require('@/assets/icon/questionIcon/30-None of these.png'),
              unique: true
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
